import { render, staticRenderFns } from "./VetManage.vue?vue&type=template&id=10b3e137&"
import script from "./VetManage.vue?vue&type=script&lang=js&"
export * from "./VetManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports